/**将会造成非预期换行的中文标点用英文标点替换
 * @method  relaceChinesePunctuations
 * @author sansengg
 * @version 2017-05-02
 * @param   {String}                  str 待转换字符串
 * @return  {[type]}                      [description]
 */
function relaceChinesePunctuations(str) {
  if (typeof str !== 'string') {
    return str;
  }
  return str.replace(/“([^“”]*)”/g, ' " $1 " ')
    .replace(/《([^《》]*)》/g, ' < $1 > ')
    .replace(/（([^（）]*)）/g, ' ( $1 ) ');
}
function findBreakPoint(text, width, context) {
  var min = 0;
  var max = text.length - 1;

  while (min <= max) {
    var middle = Math.floor((min + max) / 2);
    var middleWidth = context.measureText(text.substr(0, middle)).width;
    var oneCharWiderThanMiddleWidth = context.measureText(text.substr(0, middle + 1)).width;
    if (middleWidth <= width && oneCharWiderThanMiddleWidth > width) {
      return middle;
    }
    if (middleWidth < width) {
      min = middle + 1;
    } else {
      max = middle - 1;
    }
  }
  return -1;
}
function breakLinesForCanvas(text = '', width, font) {
  var canvas = document.createElement('canvas');
  // canvas.width = canvasSize.x;
  // canvas.height = canvasSize.y;
  var context = canvas.getContext('2d');
  var result = [];
  var breakPoint = 0;

  if (font) {
    context.font = font;
  }
  while ((breakPoint = findBreakPoint(text, width, context)) !== -1) {
    result.push(text.substr(0, breakPoint));
    text = text.substr(breakPoint);
  }

  if (text) {
    result.push(text);
  }

  return result;
}
export default {breakLinesForCanvas, relaceChinesePunctuations}



// WEBPACK FOOTER //
// ./src/utils/breakLinesForCanvas.js